import React from 'react'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

const DropzoneContent: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  const { t } = useTranslation()

  return (
    <>
      <CloudUploadIcon sx={{ color: disabled ? 'grey.300' : 'primary.main' }} />
      <Typography
        sx={{ marginTop: 0.5, textAlign: 'center', color: disabled ? 'grey.300' : 'primary.main' }}
        variant="body2"
      >
        {t('add-attachments-text')}
      </Typography>
    </>
  )
}

export default DropzoneContent
